<div class="banner row m-0 align-items-center justify-content-center">

  <mat-icon class="mr-2" [ngClass]="level==='error' ? 'mat-warn' : 'orange'">info</mat-icon>

  @if (!template) {
    <div class="banner-text" [innerHTML]="html"></div>
  } @else {
    <ng-template [ngTemplateOutlet]="template" />
  }
</div>
